import * as React from 'react';
import { styled } from '@linaria/react';
import { ColorPath } from 'types/Theme';
import { HorizontalProgressBar } from '../HorizontalProgressBar';
import { Text } from '../Text';
type Props = {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** The label for the percentage bar */
  children: React.ReactNode;
  /** The value for the percentage bar */
  value: number;
  /** Specify the color path from the theme's colors file to explicitly set the bar's color */
  colorPath?: ColorPath;
  /** The formatting of the value */
  displayFormat?: 'score' | 'percent';
};
export const LabelWrapper = /*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "lhtt0qa",
  propsAsIs: false
});
export const ProgressBarContainer = /*#__PURE__*/styled('div')({
  name: "ProgressBarContainer",
  class: "p1vkdgfj",
  propsAsIs: false
});
export const ProgressBarBar = /*#__PURE__*/styled('div')({
  name: "ProgressBarBar",
  class: "p1f9hauu",
  propsAsIs: false
});
const roundRatingValue = (value: number) => Math.round(value * 10) / 10;
const formatValue = (value: number, valueFormat: Props['displayFormat']) => {
  switch (valueFormat) {
    case 'score':
      return roundRatingValue(value);
    case 'percent':
      return `${Math.floor(value * 10)}%`;
  }
};
export const ReviewSummaryBar = ({
  children,
  value,
  displayFormat = 'score',
  colorPath,
  className
}: Props) => {
  return <div className={className}>
      <LabelWrapper>
        <Text variant="bodyS">{children}</Text>
        <Text variant="labelS">{formatValue(value, displayFormat)}</Text>
      </LabelWrapper>

      <ProgressBarContainer>
        <ProgressBarBar>
          <HorizontalProgressBar key={value} value={value * 10} colorPath={colorPath} />
        </ProgressBarBar>
      </ProgressBarContainer>
    </div>;
};

require("./ReviewSummaryBar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewSummaryBar.tsx");